/** @format */
import { feedbackFeatureToggleRedirect, genericFeedbackState, genericFeedbackThankYouState, SisStateDeclaration } from 'sis-components';
import { studentRoutes } from '../auth/student-routes';

export const feedbackRoutes: SisStateDeclaration[] = [
    // /student/feedback
    {
        ...genericFeedbackState,
        name: 'student.logged-in.feedback',
        redirectTo: feedbackFeatureToggleRedirect(studentRoutes.defaultView),
    },
    // /student/feedback/thank-you
    {
        ...genericFeedbackThankYouState,
        name: 'student.logged-in.feedback-thank-you',
        resolve: {
            homeState: () => studentRoutes.defaultView,
        },
        redirectTo: feedbackFeatureToggleRedirect(studentRoutes.defaultView),
    },
];
